import { trackInteraction } from '../../analytics';

export function addReviewsListeners() {
  const REVIEW_CHUNK_SIZE = 5;
  const loadMoreCTA = document.querySelector('.load-more-cta');
  const googleLinkCTA = document.querySelector('.google-link-cta');
  const reviewsContainer = document.querySelector('.reviews_container');
  const ratingLink = document.querySelector('.rating__link');

  if (reviewsContainer) {
    reviewsContainer.addEventListener('click', reviewsContainerHandler);

    googleLinkCTA.addEventListener('click', () => {
      trackInteraction({
        label: 'building reviews - google link'
      });
    });

    ratingLink.addEventListener('click', () => {
      trackInteraction({
        label: 'building reviews - reviews section'
      });
    });
  }

  function reviewsContainerHandler(e) {
    if (e.target.closest('.read-more-cta')) {
      const element = e.target;
      const parent = element.parentElement;
      const reviewContainer = parent.closest('.review__description');
      const originalText = reviewContainer.querySelector('.hiddent-text-content');

      originalText.classList.remove('hiddent-text');
      originalText.classList.remove('hiddent-text-content');
      parent.classList.add('hiddent-text-content');

      trackInteraction({
        label: 'building reviews - reveal truncated text'
      });
    } else if (e.target.closest('.load-more-cta')) {
      const hiddenReviews = document.querySelectorAll('div.hiddent-text');

      if (hiddenReviews && hiddenReviews.length) {
        revealReviewChunk(hiddenReviews);

        const remainingReviews = document.querySelectorAll('div.hiddent-text');
        if (remainingReviews.length === 0) {
          loadMoreCTA.classList.add('hidden-cta');
          googleLinkCTA.classList.remove('hidden-cta');
        }

        trackInteraction({
          label: 'building reviews - load more reviews'
        });
      }
    }
  }

  function revealReviewChunk(nodelist) {
    for (let i = 0; i < nodelist.length; i++) {
      if (i > REVIEW_CHUNK_SIZE - 1) break;
      nodelist[i].classList.remove('hiddent-text');
    }
  }
}
